import React from 'react'
import '../footer/footer.css'

const FooterComponent = () => {
  return (
    
        <div className="social-container">
            <ul className="social-icons">
              
                <li><a href="https://www.instagram.com/"><i className="fa fa-instagram"></i></a></li>
                
                <li><a href="https://twitter.com/"><i className="fa fa-twitter"></i></a></li>
                
                <li><a href="https://www.linkedin.com/in/abubakar-meigag-0a625a17a/"><i className="fa fa-linkedin"></i></a></li>
                
                <li><a href="https://codepen.io/"><i className="fa fa-codepen"></i></a></li>
            </ul>
        </div>
  )
}

export default FooterComponent